import React, { useState }  from 'react';

// import { About } from './components';
import SecondStep from './SecondStep';
// import Container from 'components/Container';
// import { Main } from 'layouts';
// import secondStepData from './secondStepData';
import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const analytics = Analytics({
  app: 'awesome-app',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-X34JYK01Q0']
    })
  ]
})

analytics.page()



const CloudHosting = ({handleCurrentStep, secondState}) => {

  return (

  <SecondStep handleCurrentStep={handleCurrentStep} 
  secondState = {secondState}/>

);
};


export default CloudHosting;

